export default __webpack_public_path__ + "static/0167-7c80e3f0d1a6d56443e734757bfa755f.png";